import React from 'react';
import styled from 'styled-components';
import { OrganizationInfo } from '../../../types/types';
import { OrganizationCard } from './OrganizationCard';

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  gap: 24px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 16px;
    gap: 16px;
  }
`;

interface OrganizationGridProps {
  organizations: OrganizationInfo[];
  onViewDetails?: (org: OrganizationInfo) => void;
}

const OrganizationGrid: React.FC<OrganizationGridProps> = ({ 
  organizations, 
  onViewDetails 
}) => {
  return (
    <GridContainer>
      {organizations.map((org, index) => (
        <OrganizationCard 
          key={index} 
          OrganizationInfo={org} 
          onViewDetails={() => onViewDetails?.(org)}
        />
      ))}
    </GridContainer>
  );
};

export default OrganizationGrid;